(function () {
  'use strict';

  const normalize = (value) =>
    String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\u0131/g, 'i')
      .trim();

  function initDesktopTabs(scope) {
    scope.querySelectorAll('.m-header__desktop .m-menu__item--mega > button.m-menu__link--main').forEach((control) => {
      if (control.dataset.daTabReady === 'true') return;
      control.dataset.daTabReady = 'true';
      control.addEventListener('click', () => {
        const item = control.closest('.m-menu__item--mega');
        const siteNav = window.__sfHeader && window.__sfHeader.siteNav;
        if (!item || !siteNav) return;
        const index = Number(item.dataset.index);
        if (item.classList.contains('m-menu__item--active')) {
          siteNav.onMenuItemLeave({ target: item }, index);
          control.focus({ preventScroll: true });
        } else {
          siteNav.onMenuItemEnter({ target: item }, index);
        }
      });
    });
  }

  function initMobileMenu(menu) {
    if (!menu || menu.dataset.daMenuReady === 'true') return;
    menu.dataset.daMenuReady = 'true';

    const search = menu.querySelector('[data-da-mobile-search]');
    const sections = [...menu.querySelectorAll('[data-da-mobile-section]')];
    const items = [...menu.querySelectorAll('[data-da-mobile-item]')];
    const empty = menu.querySelector('[data-da-mobile-empty]');
    const groups = sections.map((section) => ({ section, matches: 0 }));
    const records = items.map((item) => ({
      item,
      index: normalize(item.dataset.searchIndex),
      group: groups.find((group) => group.section.contains(item)),
    }));
    let filterPending = false;
    let composing = false;

    sections.forEach((section) => {
      section.addEventListener('toggle', () => {
        if (!section.open || (search && normalize(search.value))) return;
        sections.forEach((other) => {
          if (other !== section && other.open) other.open = false;
        });
      });
    });

    const filter = () => {
      const query = normalize(search && search.value);
      let visibleCount = 0;
      groups.forEach((group) => { group.matches = 0; });

      records.forEach(({ item, index, group }) => {
        const matched = !query || index.includes(query);
        if (item.hidden === matched) item.hidden = !matched;
        if (matched) {
          visibleCount += 1;
          if (group) group.matches += 1;
        }
      });

      groups.forEach(({ section, matches }) => {
        const hidden = Boolean(query) && matches === 0;
        if (section.hidden !== hidden) section.hidden = hidden;
        if (query && matches > 0 && !section.open) section.open = true;
      });

      if (!query && sections.length && !sections.some((section) => section.open)) sections[0].open = true;
      if (empty && empty.hidden !== (visibleCount > 0)) empty.hidden = visibleCount > 0;
    };

    const scheduleFilter = () => {
      if (filterPending) return;
      filterPending = true;
      window.requestAnimationFrame(() => {
        window.setTimeout(() => {
          filterPending = false;
          if (menu.isConnected && !composing) filter();
        }, 0);
      });
    };

    if (search) {
      search.addEventListener('input', (event) => {
        if (!event.isComposing) scheduleFilter();
      });
      search.addEventListener('compositionstart', () => { composing = true; });
      search.addEventListener('compositionend', () => {
        composing = false;
        scheduleFilter();
      });
      search.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !search.value) return;
        event.stopPropagation();
        search.value = '';
        scheduleFilter();
      });
    }
  }

  function init(scope) {
    initDesktopTabs(scope);
    scope.querySelectorAll('.da-mobile-nav').forEach(initMobileMenu);
  }

  const start = () => init(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
